import React, { Fragment, useEffect, useState } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { submitKingspanAssessment } from "../../redux/actions/index";
import Timer from "../Dnata/Timer";

const KingspanLiteracyAssessment = ({
  appData,
  submitKingspanAssessmentFunc,
}) => {
  const candidateName = `${appData.firstName} ${appData.lastName}`;
  const [started, setStarted] = useState(false);
  const [counter, setCounter] = useState({
    min: 19,
    sec: 59,
  });
  const testSubmitted =
    appData.kingspanOnboarding &&
    appData.kingspanOnboarding.literacyTestResultsKingspan &&
    appData.kingspanOnboarding.YKN1;

  const timerCSS = {
    position: "fixed",
    backgroundColor: "white",
    display: "flex",
    width: "80px",
    height: "40px",
    bottom: "0",
    right: "0",
    color: "black",
    fontWeight: "bold",
    fontSize: "15px",
    alignItems: "center",
    justifyContent: "center",
    border: "3px solid orange",
  };

  const inputStyle = {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
  };
  const ulStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingInlineStart: "15px",
    listStyle: "none",
  };

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";
  const initialData = {};
  const getVal = getField(initialData);

  const initialState = {
    section1: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"SECTION 1"} />
          <br />
          <div>Question 1</div>
          <br />
          <div>
            <strong>Place all 12 names in alphabetical order</strong>
          </div>
          <br />
          <div className="row">
            <ul style={ulStyle} className="col-12">
              <li>Aaron</li>
              <li>Michael</li>
              <li>Patricia</li>
              <li>Linda</li>
              <li>Angela</li>
              <li>Cheryl</li>
            </ul>
            <ul style={ulStyle} className="col-12">
              <li>David</li>
              <li>Josie</li>
              <li>Kevin</li>
              <li>Josephine</li>
              <li>Andrew</li>
              <li>Sarah</li>
            </ul>
          </div>
        </Fragment>
      ),
    },
    row1: {
      title: "1.",
      type: "text",
      value: getVal("row1"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "93%",
    },
    row2: {
      title: "2.",
      type: "text",
      value: getVal("row2"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "93%",
    },
    row3: {
      title: "3.",
      type: "text",
      value: getVal("row3"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "93%",
    },
    row4: {
      title: "4.",
      type: "text",
      value: getVal("row4"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "93%",
    },
    row5: {
      title: "5.",
      type: "text",
      value: getVal("row5"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "93%",
    },
    row6: {
      title: "6.",
      type: "text",
      value: getVal("row6"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "93%",
    },
    row7: {
      title: "7.",
      type: "text",
      value: getVal("row7"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "93%",
    },
    row8: {
      title: "8.",
      type: "text",
      value: getVal("row8"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "93%",
    },
    row9: {
      title: "9.",
      type: "text",
      value: getVal("row9"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "93%",
    },
    row10: {
      title: "10.",
      type: "text",
      value: getVal("row10"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "93%",
    },
    row11: {
      title: "11.",
      type: "text",
      value: getVal("row11"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "93%",
    },
    row12: {
      title: "12.",
      type: "text",
      value: getVal("row12"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "93%",
    },
    section2: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"SECTION 2"} />
          <br />
          <div>
            <strong>
              Within each row, please find the number that does not match the
              others and select that number below.
            </strong>
          </div>
          <br />
          <table className="table text-center table-responsive">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">a</th>
                <th scope="col">b</th>
                <th scope="col">c</th>
                <th scope="col">d</th>
                <th scope="col">e</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1.</th>
                <td>554321</td>
                <td>554321</td>
                <td>554321</td>
                <td>544321</td>
                <td>554321</td>
              </tr>
              <tr>
                <th scope="row">2.</th>
                <td>639214</td>
                <td>638214</td>
                <td>639214</td>
                <td>639214</td>
                <td>639214</td>
              </tr>
              <tr>
                <th scope="row">3.</th>
                <td>743211</td>
                <td>743111</td>
                <td>743211</td>
                <td>743211</td>
                <td>743211</td>
              </tr>
              <tr>
                <th scope="row">4.</th>
                <td>222222</td>
                <td>222222</td>
                <td>222222</td>
                <td>22222</td>
                <td>222222</td>
              </tr>
              <tr>
                <th scope="row">5.</th>
                <td>350403</td>
                <td>305403</td>
                <td>350403</td>
                <td>350403</td>
                <td>350403</td>
              </tr>
            </tbody>
          </table>
        </Fragment>
      ),
    },
    row13: {
      title: "Row 1:",
      value: getVal("row13"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "554321", value: "a" },
        { label: "554321", value: "b" },
        { label: "554321", value: "c" },
        { label: "544321", value: "d" },
        { label: "554321", value: "e" },
      ],
    },
    row14: {
      title: "Row 2:",
      value: getVal("row14"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "639214", value: "a" },
        { label: "638214", value: "b" },
        { label: "639214", value: "c" },
        { label: "639214", value: "d" },
        { label: "639214", value: "e" },
      ],
    },
    row15: {
      title: "Row 3:",
      value: getVal("row15"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "743211", value: "a" },
        { label: "743111", value: "b" },
        { label: "743211", value: "c" },
        { label: "743211", value: "d" },
        { label: "743211", value: "e" },
      ],
    },
    row16: {
      title: "Row 4:",
      value: getVal("row16"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "222222", value: "a" },
        { label: "222222", value: "b" },
        { label: "222222", value: "c" },
        { label: "22222", value: "d" },
        { label: "222222", value: "e" },
      ],
    },
    row17: {
      title: "Row 5:",
      value: getVal("row17"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "350403", value: "a" },
        { label: "305403", value: "b" },
        { label: "305403", value: "c" },
        { label: "305403", value: "d" },
        { label: "305403", value: "e" },
      ],
    },
    section3: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"SECTION 3"} />
          <br />
          <div>
            <strong>
              Please find the “odd one out” in the following sequences and
              select the corresponding word below.
            </strong>
          </div>
          <br />
          <table className="table text-center table-responsive">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">a</th>
                <th scope="col">b</th>
                <th scope="col">c</th>
                <th scope="col">d</th>
                <th scope="col">e</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1.</th>
                <td>Car</td>
                <td>Lorry</td>
                <td>Cycle</td>
                <td>Egg</td>
                <td>Van</td>
              </tr>
              <tr>
                <th scope="row">2.</th>
                <td>Four</td>
                <td>Seven</td>
                <td>Ninety</td>
                <td>Zero</td>
                <td>Red</td>
              </tr>
              <tr>
                <th scope="row">3.</th>
                <td>Jump</td>
                <td>Stool</td>
                <td>Run</td>
                <td>Skip</td>
                <td>Walk</td>
              </tr>
              <tr>
                <th scope="row">4.</th>
                <td>Newspaper</td>
                <td>Magazine</td>
                <td>Manuscript</td>
                <td>Torch</td>
                <td>Book</td>
              </tr>
              <tr>
                <th scope="row">5.</th>
                <td>Telephone</td>
                <td>Kidney</td>
                <td>Heart</td>
                <td>Leg</td>
                <td>Elbow</td>
              </tr>
            </tbody>
          </table>
        </Fragment>
      ),
    },
    row18: {
      title: "Row 1:",
      value: getVal("row18"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Car", value: "a" },
        { label: "Lorry", value: "b" },
        { label: "Cycle", value: "c" },
        { label: "Egg", value: "d" },
        { label: "Van", value: "e" },
      ],
    },
    row19: {
      title: "Row 2:",
      value: getVal("row19"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Four", value: "a" },
        { label: "Seven", value: "b" },
        { label: "Ninety", value: "c" },
        { label: "Zero", value: "d" },
        { label: "Red", value: "e" },
      ],
    },
    row20: {
      title: "Row 3:",
      value: getVal("row20"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Jump", value: "a" },
        { label: "Stool", value: "b" },
        { label: "Run", value: "c" },
        { label: "Skip", value: "d" },
        { label: "Walk", value: "e" },
      ],
    },
    row21: {
      title: "Row 4:",
      value: getVal("row21"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Newspaper", value: "a" },
        { label: "Magazine", value: "b" },
        { label: "Manuscript", value: "c" },
        { label: "Torch", value: "d" },
        { label: "Book", value: "e" },
      ],
    },
    row22: {
      title: "Row 5:",
      value: getVal("row22"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Telephone", value: "a" },
        { label: "Kidney", value: "b" },
        { label: "Heart", value: "c" },
        { label: "Leg", value: "d" },
        { label: "Elbow", value: "e" },
      ],
    },
    section4: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"SECTION 4"} />
          <br />
          <div>
            <strong>
              Please find the correctly spelt in each row and select the
              corresponding word below.
            </strong>
          </div>
          <br />
          <table className="table text-center table-responsive">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">a</th>
                <th scope="col">b</th>
                <th scope="col">c</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1.</th>
                <td>Distrebution</td>
                <td>Distribution</td>
                <td>Ditsributiuon</td>
              </tr>
              <tr>
                <th scope="row">2.</th>
                <td>Logistics</td>
                <td>Logitsics</td>
                <td>Logistis</td>
              </tr>
              <tr>
                <th scope="row">3.</th>
                <td>Packaging</td>
                <td>Pcakaging</td>
                <td>Pakaging</td>
              </tr>
              <tr>
                <th scope="row">4.</th>
                <td>Operativ</td>
                <td>Operative</td>
                <td>Oparative</td>
              </tr>
              <tr>
                <th scope="row">5.</th>
                <td>Folk Lift Truck</td>
                <td>Fork Lift Truck</td>
                <td>Forc Left Truck</td>
              </tr>
              <tr>
                <th scope="row">6.</th>
                <td>Narow Aisle</td>
                <td>Narrow isle</td>
                <td>Narrow Aisle</td>
              </tr>
              <tr>
                <th scope="row">7.</th>
                <td>Labeling</td>
                <td>Labelling</td>
                <td>Labbeling</td>
              </tr>
              <tr>
                <th scope="row">8.</th>
                <td>Saycurity</td>
                <td>Securitey</td>
                <td>Security</td>
              </tr>
              <tr>
                <th scope="row">9.</th>
                <td>Contract</td>
                <td>Contrakt</td>
                <td>Centract</td>
              </tr>
              <tr>
                <th scope="row">10.</th>
                <td>Fire Exitt</td>
                <td>Fire Exit</td>
                <td>Fire Exet</td>
              </tr>
            </tbody>
          </table>
        </Fragment>
      ),
    },
    row23: {
      title: "Row 1:",
      value: getVal("row23"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Distrebution", value: "a" },
        { label: "Distribution", value: "b" },
        { label: "Ditsributiuon", value: "c" },
      ],
    },
    row24: {
      title: "Row 2:",
      value: getVal("row24"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Logistics", value: "a" },
        { label: "Logitsics", value: "b" },
        { label: "Logistis", value: "c" },
      ],
    },
    row25: {
      title: "Row 3:",
      value: getVal("row25"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Packaging", value: "a" },
        { label: "Pcakaging", value: "b" },
        { label: "Pakaging", value: "c" },
      ],
    },
    row26: {
      title: "Row 4:",
      value: getVal("row26"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Operativ", value: "a" },
        { label: "Operative", value: "b" },
        { label: "Oparative", value: "c" },
      ],
    },
    row27: {
      title: "Row 5:",
      value: getVal("row27"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Folk Lift Truck", value: "a" },
        { label: "Fork Lift Truck", value: "b" },
        { label: "Forc Left Truck", value: "c" },
      ],
    },
    row28: {
      title: "Row 6:",
      value: getVal("row28"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Narow Aisle", value: "a" },
        { label: "Narrow isle", value: "b" },
        { label: "Narrow Aisle", value: "c" },
      ],
    },
    row29: {
      title: "Row 7:",
      value: getVal("row29"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Labeling", value: "a" },
        { label: "Labelling", value: "b" },
        { label: "Labbeling", value: "c" },
      ],
    },
    row30: {
      title: "Row 8:",
      value: getVal("row30"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Saycurity", value: "a" },
        { label: "Securitey", value: "b" },
        { label: "Security", value: "c" },
      ],
    },
    row31: {
      title: "Row 9:",
      value: getVal("row31"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Contract", value: "a" },
        { label: "Contrakt", value: "b" },
        { label: "Centract", value: "c" },
      ],
    },
    row32: {
      title: "Row 10:",
      value: getVal("row32"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Fire Exitt", value: "a" },
        { label: "Fire Exit", value: "b" },
        { label: "Fire Exet", value: "c" },
      ],
    },
    section5: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"SECTION 5"} />
          <br />
          <div>
            <strong>Please copy the number.</strong>
          </div>
        </Fragment>
      ),
    },
    row33: {
      title: "53442123567",
      type: "text",
      value: getVal("row33"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "65%",
    },
    row34: {
      title: "77657899329",
      type: "text",
      value: getVal("row34"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "65%",
    },
    row35: {
      title: "5316925433",
      type: "text",
      value: getVal("row35"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "65%",
    },
    row36: {
      title: "8585583678",
      type: "text",
      value: getVal("row36"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "65%",
    },
    section6: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"SECTION 6"} />
          <br />
          <div>
            <strong>Please copy the word.</strong>
          </div>
        </Fragment>
      ),
    },
    row37: {
      title: "Allocation",
      type: "text",
      value: getVal("row37"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "65%",
    },
    row38: {
      title: "Canteen",
      type: "text",
      value: getVal("row38"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "65%",
    },
    row39: {
      title: "Transport",
      type: "text",
      value: getVal("row39"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "65%",
    },
    row40: {
      title: "Operations",
      type: "text",
      value: getVal("row40"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "65%",
    },
    section7: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"SECTION 7"} />
          <br />
          <div>
            <strong>
              Please write the following amounts in words using capital letters.
            </strong>
          </div>
        </Fragment>
      ),
    },
    row41: {
      title: "£5,449",
      type: "text",
      value: getVal("row41"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "80%",
    },
    row42: {
      title: "£1,995",
      type: "text",
      value: getVal("row42"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "80%",
    },
    row43: {
      title: "£888",
      type: "text",
      value: getVal("row43"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "80%",
    },
    row44: {
      title: "£1,205",
      type: "text",
      value: getVal("row44"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "80%",
    },
    section8: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"SECTION 8"} />
          <br />
          <div>
            <strong>
              Please convert the following from 24 hour clock to 12 hour clock.
              Please specify am or pm.
            </strong>
          </div>
        </Fragment>
      ),
    },
    row45: {
      title: "23.45",
      type: "text",
      value: getVal("row45"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "80%",
    },
    row46: {
      title: "16.15",
      type: "text",
      value: getVal("row46"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "80%",
    },
    row47: {
      title: "13.30",
      type: "text",
      value: getVal("row47"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "80%",
    },
    section9: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"SECTION 9"} />
          <br />
          <div>
            <strong>
              Now convert the following times to the 24 hour clock.
            </strong>
          </div>
        </Fragment>
      ),
    },
    row48: {
      title: "10.45pm",
      type: "text",
      value: getVal("row48"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "80%",
    },
    row49: {
      title: "3.15am",
      type: "text",
      value: getVal("row49"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "80%",
    },
    row50: {
      title: "6.30pm",
      type: "text",
      value: getVal("row50"),
      seeAsterix: false,
      style: inputStyle,
      inputWidth: "80%",
    },
  };

  const [fields, setField] = useForm(initialState);

  const redirectBack = () => history.push("/profile/edit/kingspan-onboarding");

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitKingspanAssessmentFunc("YKN1", {
      ...fieldValuesPayload,
      name: candidateName,
      signature: candidateName,
      date: moment().format("DD/MM/YYYY"),
    });
    redirectBack();
  };

  useEffect(() => {
    if (testSubmitted) {
      redirectBack();
    }
    if (counter.min === 0 && counter.sec === 0) {
      handleSubmit();
    }
  }, [counter]);

  return !started ? (
    <div className="container d-flex flex-column align-items-center justify-content-center pt-2">
      <h2 style={{ padding: "0 1rem" }}>Numeracy & Literacy Test</h2>
      <p style={{ padding: "1rem" }}>
        This is a test to find out how you deal with information that is
        presented in a variety of ways.
        <br />
        You will be given 20 minutes to do the complete test.
        <br />
        The timer will be visible to you throughout the test in the bottom right
        corner.
        <br />
        You can only complete the test once.
        <br />
        When you are ready please press the Start button.
      </p>
      <button
        className="btn btn-primary"
        style={{ width: "280px", margin: "1rem 0" }}
        onClick={() => setStarted(true)}
      >
        Start
      </button>
    </div>
  ) : (
    <Fragment>
      <FormCreator
        formTitle={"Numeracy & Literacy Test"}
        fields={fields}
        setField={setField}
        handleSubmit={handleSubmit}
        handleCancel={() => redirectBack()}
        helper={""}
      />
      <div style={timerCSS}>
        <Timer
          counter={counter}
          setCounter={setCounter}
          timeLimitInMinutes={20}
        />
      </div>
    </Fragment>
  );
};

KingspanLiteracyAssessment.propTypes = {
  submitKingspanAssessmentFunc: func,
  appData: any,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const mapDispatchToProps = {
  submitKingspanAssessmentFunc: submitKingspanAssessment,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(KingspanLiteracyAssessment);
